import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-system-error',
  templateUrl: './system-error.component.html',
  styleUrls: ['./system-error.component.scss']
})
export class SystemErrorComponent implements OnInit {
  previousRoute: any;
  link: string;

  constructor( private breadCrumbService: BreadCrumbService,
  private router: Router) {

  }

  ngOnInit() {
    this.link = this.breadCrumbService.getLastUrlFromBreadCrumb().label;
  }

  backToPreviousPage() {
    const previousPage = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    this.router.navigate([previousPage]);
  }
}
